// extracted by mini-css-extract-plugin
export var emphasizeQuantity = "_e8-3";
export var flatBottomCorners = "_e8-5";
export var productImage = "_e8-0";
export var quantityContainer = "_e8-2";
export var quantityHeader = "_e8-6";
export var tooltip = "_e8-1";
export var wrapAndEllipsesOverflow = "_e8-4";